export const DESKTOP_ROW_POSITION = 3
export const MOBILE_ROW_POSITION = 6
export const FEEDBACK_BUTTON_SIZE_PX = '48px'
